import type { BlogFrontmatter } from "@/lib/types";
import BlogCard from "./BlogCard";

type Props = {
  posts: BlogFrontmatter[];
  searchQuery?: string;
};

function Blogs({ posts, searchQuery = "" }: Props) {
  const filtered = posts.filter((blog) => {
    const q = searchQuery.toLowerCase();
    return (
      blog.title.toLowerCase().includes(q) ||
      (blog.category ?? "").toLowerCase().includes(q)
    );
  });

  const emptyMessage = searchQuery
    ? `No articles found for "${searchQuery}"`
    : "No articles available yet.";

  return (
    <div className="py-12 px-4 min-[1240px]:px-0">
      <div className="max-w-[1200px] mx-auto flex flex-col gap-6">
        {filtered.length > 0 ? (
          filtered.map((blog) => <BlogCard key={blog.slug} blog={blog} />)
        ) : (
          <p className="text-center text-white/60 font-inter py-16">
            {emptyMessage}
          </p>
        )}
      </div>
    </div>
  );
}

export default Blogs;
